import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { IDownloadNFEResponse } from '../long-steel-orders/types';
import { ECustomerTypeView } from '../user/types';
import {
  Types,
  IInvoicesResponse,
  IInvoiceCreditsResponse,
  IInvoiceData,
  IInvoiceBilletResponse,
  IInvoiceXMLResponse
} from './types';

export const loadDuplicates = (
  customerId: string,
  customerViewType: ECustomerTypeView,
  startDate?: moment.Moment,
  endDate?: moment.Moment,
  needToLoadCustomer?: boolean,
  selectedStatus?: string
) =>
  action(Types.LOAD_DUPLICATES, {
    customerId,
    customerViewType,
    startDate,
    endDate,
    needToLoadCustomer,
    selectedStatus
  });

export const loadDuplicatesSuccess = (invoicesResponse: IInvoicesResponse) =>
  action(Types.LOAD_DUPLICATES_SUCCESS, { invoicesResponse });
export const loadDuplicatesFailure = (error: unknown, bpError?: boolean) =>
  action(Types.LOAD_DUPLICATES_FAILURE, { error, bpError });

export const filterDuplicatesByDate = (
  startDate: moment.Moment,
  endDate: moment.Moment
) => action(Types.FILTER_DUPLICATES_BY_DATE, { startDate, endDate });
export const filterDuplicatesByDateSuccess = (
  filteredInvoices: IInvoiceData[]
) => action(Types.FILTER_DUPLICATES_BY_DATE_SUCCESS, { filteredInvoices });
export const loadOldInvoices = (oldInvoices: IInvoiceData[]) =>
  action(Types.LOAD_OLD_INVOICES, { oldInvoices });

// invoiceCredits
export const loadInvoiceCredits = (customerId: string) =>
  action(Types.LOAD_INVOICE_CREDITS, { customerId });
export const loadInvoiceCreditsSuccess = (
  invoiceCreditsResponse: IInvoiceCreditsResponse
) => action(Types.LOAD_INVOICE_CREDITS_SUCCESS, { invoiceCreditsResponse });
export const loadInvoiceCreditsFailure = (error: unknown) =>
  action(Types.LOAD_INVOICE_CREDITS_FAILURE, { error });

// NF
export const loadNFFileFromFinancials = (
  invoiceItem: IInvoiceData,
  customerId: string,
  customerViewType: ECustomerTypeView
) => action(Types.LOAD_NF_FILE, { invoiceItem, customerId, customerViewType });
export const loadNFFileFromFinancialsSuccess = (
  invoiceItem: IInvoiceData,
  downloadNFEResponse: IDownloadNFEResponse
) => action(Types.LOAD_NF_FILE_SUCCESS, { invoiceItem, downloadNFEResponse });
export const loadNFFileFromFinancialsFailure = (
  invoiceItem: IInvoiceData,
  error: unknown
) => action(Types.LOAD_NF_FILE_FAILURE, { invoiceItem, error });
export const downloadNFFileFromFinancials = (invoiceItem: IInvoiceData) =>
  action(Types.DOWNLOAD_NF_FILE, { invoiceItem });

// BILLET (segunda via boleto)
export const loadInvoiceBillet = (invoiceItem: IInvoiceData) =>
  action(Types.LOAD_INVOICE_BILLET, { invoiceItem });
export const loadInvoiceBilletSuccess = (
  invoiceItem: IInvoiceData,
  invoiceBilletResponse: IInvoiceBilletResponse
) =>
  action(Types.LOAD_INVOICE_BILLET_SUCCESS, {
    invoiceItem,
    invoiceBilletResponse
  });
export const loadInvoiceBilletFailure = (
  invoiceItem: IInvoiceData,
  error: unknown
) => action(Types.LOAD_INVOICE_BILLET_FAILURE, { invoiceItem, error });
export const downloadInvoiceBillet = (invoiceItem: IInvoiceData) =>
  action(Types.DOWNLOAD_INVOICE_BILLET, { invoiceItem });

export const clearInvoicesState = (customerViewType?: ECustomerTypeView) =>
  action(Types.CLEAR_INVOICES_STATE, { customerViewType });

export const loadInvoiceXml = (invoiceItem: IInvoiceData) =>
  action(Types.LOAD_INVOICE_XML, { invoiceItem });

export const loadInvoiceXmlSuccess = (
  invoiceItem: IInvoiceData,
  downloadXmlResponse: IInvoiceXMLResponse
) =>
  action(Types.LOAD_INVOICE_XML_SUCCESS, { invoiceItem, downloadXmlResponse });

export const loadInvoiceXmlFailure = (
  invoiceItem: IInvoiceData,
  error: AxiosError
) => action(Types.LOAD_INVOICE_XML_FAILURE, { invoiceItem, error });

export const downloadInvoiceXml = (invoiceItem: IInvoiceData) =>
  action(Types.DOWNLOAD_INVOICE_XML, { invoiceItem });
